import { render, staticRenderFns } from "./SmsBroadcastBuilderModal.vue?vue&type=template&id=b219c55c&scoped=true"
import script from "./SmsBroadcastBuilderModal.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastBuilderModal.vue?vue&type=style&index=0&id=b219c55c&prod&lang=scss&scoped=true"
import style1 from "./SmsBroadcastBuilderModal.vue?vue&type=style&index=1&id=b219c55c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b219c55c",
  null
  
)

export default component.exports